import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, TitleCasePipe } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { IonicModule } from "@ionic/angular";
import { NgbModalModule, NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { FlexLayoutModule } from "@angular/flex-layout";
import { PhysicianRoutingModule } from "./physician-routing.module";
import { PhysicianService } from "./physician.service";
import { PhysicianLayoutComponent } from "./layout/physician-layout.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { PracticeProfileComponent } from "./profile/practice/practice-profile.component";
import { EditProfileComponent } from "./profile/editProfile.component";
import { HeaderComponent } from "./setup/header.component";
import { MaterialModule } from "../material/material-module";
import { AgmCoreModule } from "@agm/core";
import { RatingModule } from "ng-starrating";
import { PracticeOverviewEditComponent } from "./profile/practice/practice-overview-edit/practice-overview-edit.component";
import { PracticeProfilesComponent } from "./profile/practice/practice-profiles/practice-profiles.component";
import { PracticeAdminStaffEditComponent } from "./profile/practice/practice-admin-staff-edit/practice-admin-staff-edit.component";
import { MidLevelProfilesComponent } from "./profile/mid-level/mid-level-profiles/mid-level-profiles.component";
import { StaffProfilesComponent } from "./profile/staff/staff-profiles/staff-profiles.component";
import { AuthService } from "../auth/auth.service";
import { LoginGuard } from "../auth/loginGuard";
import { MatFormFieldModule, MatInputModule, MatStepperModule, MatTabsModule } from "@angular/material";
import { SetupOverviewComponent } from "./setup/setup-overview/setup-overview.component";
import { LayoutheaderComponent } from "./layout/layoutheader/layoutheader.component";
import { SigninComponent } from "./signin/signin.component";
import { LayoutsidebarComponent } from "./layout/layoutsidebar/layoutsidebar.component";
import { ComingSoonComponent } from "./coming-soon/coming-soon.component";
import { SharedModule } from "../shared/shared.module";
import { CoreModule } from "../core/core.module";
import { CKEditorModule } from "ckeditor4-angular";
import { UserService } from "../core/services/v2/user.service";
import { SetupSummaryComponent } from "./setup/setup-summary/setup-summary/setup-summary.component";
import { PracticeSummaryComponent } from "./setup/setup-summary/practice-summary/practice-summary.component";
import { CareGiverComponent } from "./setup/profiles/care-giver/care-giver.component";
import { PhysicianComponent } from "./setup/profiles/physician/physician.component";
import { PhysicianAssistantComponent } from "./setup/profiles/physician-assistant/physician-assistant.component";
import { StaffComponent } from "./setup/profiles/staff/staff.component";
import { HealthSystemPickerComponent } from "./setup/profiles/Shared/health-system-picker/health-system-picker.component";
import { SummaryListComponent } from "./setup/profiles/Shared/summary-list/summary-list.component";
import { SetupPracticeComponent } from "./setup/setup-practice/setup-practice.component";
import { PracticesComponent } from "./setup/profiles/practices/practices.component";
import { PhysicianFavoritesComponent } from "./favorites/physician-favorites/physician-favorites.component";
import { SidebarPhysicianFavoritesComponent } from "./favorites/sidebar-physician-favorites/sidebar-physician-favorites.component";
import { LayoutsubheaderComponent } from "./layout/layoutsubheader/layoutsubheader.component";
import { SetupCheckoutComponent } from "./setup/setup-checkout/setup-checkout.component";
import { SetupCreditCardFormComponent } from "./setup/setup-checkout/setup-CreditCard-form/setup-CreditCard-form.component";
import { SetupRoleGroupCheckoutComponent } from "./setup/setup-checkout/setup-RoleGroupCheckout/setup-RoleGroupCheckout.component";
import { SetupCompleteComponent } from "./setup/setup-checkout/setup-complete.component";
import { NgxMaskModule } from "ngx-mask";
import { ManagedProfessionalsComponent } from "../admin/managed-professionals/managed-professionals.component";
import { AdvancedPracticeProfessionalComponent } from "./setup/profiles/app/advanced-practice-professional.component";
import { PracticeManagerFormComponent } from "./setup/profiles/practice-manager-form/practice-manager-form.component";
import { InactiveUserComponent } from "./InactiveUser/InactiveUser.component";
import { PhysicianLayoutWithoutSelectorComponent } from "./layout/physician-layout-without-selector.Component";
import { SetupPaymentMethodComponent } from "./setup/setup-payment-method/setup-payment-method.component";
import { CreditCardViewComponent } from "./setup/setup-payment-method/credit-card-view/credit-card-view.component";
import { PaymentsListComponent } from "./setup/payments-list/payments-list.component";
import { ListSearchFormsComponent } from "./formdocs/list-search-forms/list-search-forms.component";
import { FormDocumentPreviewComponent } from "./formdocs/form-document-preview/form-document-preview.component";
import { SetupOrganizationComponent } from "./setup/setup-organization/setup-organization.component";
import { SetupOrganizationFormComponent } from "./setup/setup-organization/setup-organization-form/setup-organization-form.component";
import { SetupOrganizationEditorComponent } from "./setup/setup-organization/setup-organization-editor/setup-organization-editor.component";
import { FormTemplateDetailsComponent } from "./formdocs/form-template-details/form-template-details.component";
import { ChatComponent } from "./chat/chat.component";
import { ReplyMessageComponent } from "./chat/reply-message/reply-message.component";
import { FormTemplatePreviewComponent } from "./formdocs/form-preview/form-template-preview.component";
import { FormPreviewFromBuilderDtoComponent } from "./formdocs/form-preview/form-preview-from-builder-dto.component";
import { GetPatientDataOptionPipe } from "../shared/pipes/get-patient-data-option.pipe";
import { PhysicianReviewComponent } from "./shared/physician-review/physician-review.component";
import { PhysicianReviewDetailsComponent } from "./shared/physician-review-details/physician-review-details.component";
import { PhysicianTestimonialsComponent } from "./shared/physician-testimonials/physician-testimonials.component";
import { FormFixeddesignPreviewComponent } from "./formdocs/form-fixeddesign-preview/form-fixeddesign-preview.component";
import { FixeddesignFormsComponent } from "./formdocs/fixeddesign-forms/fixeddesign-forms.component";
import { QuillModule } from "ngx-quill";
import { DesignHeaderComponent } from "./formdocs/design-header/design-header.component";
import { AttorneyComponent } from "./setup/profiles/attorney/attorney.component";
import { CaseManagerComponent } from "./setup/profiles/case-manager/case-manager.component";
import { AddPdfformComponent } from "./formdocs/add-pdfform/add-pdfform.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MatSelectModule } from "@angular/material/select";
import { ProfileSummaryTableComponent } from "./setup/setup-summary/setup-summary/profile-summary-table/profile-summary-table.component";
import { EllipsisModule } from "ngx-ellipsis";
import { FolderEditdialogComponent } from "./formdocs/form-folder-management/folder-editdialog/folder-editdialog.component";
import { ChartsModule, ThemeService } from "ng2-charts";
import { DiscoverComponent } from "./discover/discover.component";
import { SubscriptionComponent } from './subscription/subscription/subscription.component';
import { NewDashboardComponent } from './dashboard/new-dashboard/new-dashboard.component';
import { OldDashboardComponent } from './dashboard/old-dashboard/old-dashboard.component';
import { SettingsComponent } from './settings/settings.component';

@NgModule({
  imports: [
    ChartsModule,
    EllipsisModule,
    ScrollingModule,
    RatingModule,
    PhysicianRoutingModule,
    FormsModule,
    CommonModule,
    IonicModule,
    MatStepperModule,
    MatSelectModule,
    FlexLayoutModule,
    HttpClientModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    AgmCoreModule,
    ReactiveFormsModule,
    SharedModule,
    CoreModule,
    CKEditorModule,
    MatTabsModule,
    NgxMaskModule.forRoot(),
    QuillModule.forRoot(),
  ],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    PhysicianService,
    UserService,
    AuthService,
    LoginGuard,
    TitleCasePipe,
    GetPatientDataOptionPipe,
    ThemeService,
  ],
  declarations: [
    PhysicianLayoutComponent,
    PhysicianLayoutWithoutSelectorComponent,
    DashboardComponent,
    PracticeProfileComponent,
    EditProfileComponent,
    HeaderComponent,
    PracticeOverviewEditComponent,
    PracticeAdminStaffEditComponent,
    PracticeProfilesComponent,
    MidLevelProfilesComponent,
    StaffProfilesComponent,
    SetupOverviewComponent,
    LayoutheaderComponent,
    SigninComponent,
    LayoutsidebarComponent,
    ComingSoonComponent,
    SetupSummaryComponent,
    SummaryListComponent,
    PracticeSummaryComponent,
    HealthSystemPickerComponent,
    PhysicianComponent,
    PhysicianAssistantComponent,
    CareGiverComponent,
    StaffComponent,
    SetupPracticeComponent,
    PracticesComponent,
    PhysicianFavoritesComponent,
    SidebarPhysicianFavoritesComponent,
    LayoutsubheaderComponent,
    SetupCheckoutComponent,
    SetupCreditCardFormComponent,
    SetupRoleGroupCheckoutComponent,
    SetupCompleteComponent,
    ManagedProfessionalsComponent,
    AdvancedPracticeProfessionalComponent,
    PracticeManagerFormComponent,
    InactiveUserComponent,
    SetupPaymentMethodComponent,
    CreditCardViewComponent,
    PaymentsListComponent,
    ListSearchFormsComponent,
    SetupOrganizationComponent,
    SetupOrganizationFormComponent,
    SetupOrganizationEditorComponent,
    FormTemplateDetailsComponent,
    FormTemplateDetailsComponent,
    ChatComponent,
    ReplyMessageComponent,
    FormTemplatePreviewComponent,
    PhysicianReviewComponent,
    PhysicianReviewDetailsComponent,
    PhysicianTestimonialsComponent,
    FormFixeddesignPreviewComponent,
    FixeddesignFormsComponent,
    DesignHeaderComponent,
    AttorneyComponent,
    CaseManagerComponent,
    AddPdfformComponent,
    ProfileSummaryTableComponent,
    FolderEditdialogComponent,
    DiscoverComponent,
    SubscriptionComponent,
    NewDashboardComponent,
    OldDashboardComponent,
    SettingsComponent,
    //FormAcroformdesignComponent,
  ],
  entryComponents: [
    PracticeOverviewEditComponent,
    PracticeAdminStaffEditComponent,
    PracticeManagerFormComponent,
    SetupCreditCardFormComponent,
    SetupOrganizationEditorComponent,
    FormTemplateDetailsComponent,
    FormDocumentPreviewComponent,
    FormPreviewFromBuilderDtoComponent,
    ReplyMessageComponent,
    PhysicianReviewComponent,
    PhysicianReviewDetailsComponent,
    PhysicianTestimonialsComponent,
    FormFixeddesignPreviewComponent,
    DesignHeaderComponent,
    AddPdfformComponent,
    FolderEditdialogComponent,
  ],
  bootstrap: [
    PhysicianLayoutComponent,
    PhysicianLayoutWithoutSelectorComponent,
  ],
})
export class PhysicianModule {}
